import { render, staticRenderFns } from "./OrderSimsTable.vue?vue&type=template&id=d8279fd2&"
import script from "./OrderSimsTable.vue?vue&type=script&lang=js&"
export * from "./OrderSimsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports